import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-974f15b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-login__item user-login__reset" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-login__sec" }, "重置密码", -1))
const _hoisted_3 = { class: "user-login__reset-foot" }

import { ref, defineModel } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef, FormData } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { setAPassword } from '../data-source/apis';
import { useSetup } from '../store';


export default /*#__PURE__*/_defineComponent({
  __name: 'login-reset',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel(__props, "modelValue");

const store = useSetup();
// 表单实例
const formRef = ref<FormRef>(null);
const formData = ref<FormData>({
  [FormItemEnum.agreement]: store.loginData.agreement
});

const onCancel = () => {
  model.value = 'login-forget';
  store.setLoginData({
    [FormItemEnum.agreement]: formRef.value.data[FormItemEnum.agreement]
  });
};
const onLogin = async () => {
  await formRef.value.validate();
  await setAPassword({
    [FormItemEnum.pwd]: formRef.value.data[FormItemEnum.pwd],
    [FormItemEnum.pwd2]: formRef.value.data[FormItemEnum.pwd2],
    authentication: store.info.authentication
  });
  store.login();
  model.value = 'login-success';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(LoginForm), {
      ref_key: "formRef",
      ref: formRef,
      itemList: [_unref(FormItemEnum).pwd, _unref(FormItemEnum).pwd2, _unref(FormItemEnum).agreement],
      formData: formData.value,
      pageType: _unref(LoginTypeEnum).RESET
    }, null, 8, ["itemList", "formData", "pageType"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("上一步")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { click: onLogin }, {
        default: _withCtx(() => [
          _createTextVNode("提交")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})